<mat-tab-group (selectedIndexChange)="onTabChange($event)">

    <!-- Dashboard -->
    <mat-tab label="Dashboard">
      <div class="log-container">      
        <button mat-icon-button (click)="fetchLogs('dashboard')" color="primary" [disabled]="loading"><mat-icon>sync</mat-icon></button>
        <button mat-icon-button (click)="clearLogs('dashboard')" color="primary" [disabled]="loading"><i class="fa-solid fa-trash-can"></i></button>
  
        <div *ngIf="loading">Loading logs...</div>
      
        <pre class="log-window">{{ logs }}</pre> <!-- Maintains formatting -->
      </div>
    </mat-tab>

    <!-- WebApp -->
    <mat-tab label="App">
      <div class="log-container">
      
        <button mat-icon-button (click)="fetchLogs('webapp')" color="primary" [disabled]="loading"><mat-icon>sync</mat-icon></button>
        <button mat-icon-button (click)="clearLogs('webapp')" color="primary" [disabled]="loading"><i class="fa-solid fa-trash-can"></i></button>
    
        <div *ngIf="loading">Loading logs...</div>
      
        <pre class="log-window">{{ logs }}</pre> <!-- Maintains formatting -->
      </div>
    </mat-tab>

</mat-tab-group>

